var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"wrapper"},[_c('router-view',{attrs:{"name":"sidebar"}}),_c('div',{staticClass:"content-page pb-0"},[_c('div',{staticClass:"content"},[_c('router-view',{attrs:{"name":"topbar"}}),_c('router-view')],1)])],1),_c('div',{staticClass:"rightbar-overlay"})])
}
var staticRenderFns = []

export { render, staticRenderFns }